export default "/static/build/americanexpress.png";